import { render, staticRenderFns } from "./OrderConfigEditor.vue?vue&type=template&id=5b7ae805&scoped=true"
import script from "./OrderConfigEditor.vue?vue&type=script&lang=js"
export * from "./OrderConfigEditor.vue?vue&type=script&lang=js"
import style0 from "./OrderConfigEditor.vue?vue&type=style&index=0&id=5b7ae805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7ae805",
  null
  
)

export default component.exports